<template>
  <div class="modal-mobile">
    <img class="modal-mobile-image" :src="modalImagePath" alt="modal" />
    <img class="modal-mobile-twitter" :src="twitterImagePath" alt="twitterLink" />
    <div class="modal-mobile-close-button" @click="hide">
      ×
    </div>
  </div>
</template>

<script>
export default {
  name: 'CharacterModalMobile',
  props: {
    keyName: String
  },
  computed: {
    modalImagePath() {
      return require(`../../assets/images/${this.keyName}Modal.png`)
    },
    twitterImagePath() {
      return require(`../../assets/images/${this.keyName}TwitterLink.png`)
    }
  },
  methods: {
    hide() {
      this.$modal.hide(`character-modal-${this.keyName}-mobile`)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../stylesheets/variables';

.modal {
  &-mobile {
    position: relative;
    width: 90vw;
    height: 95vh;

    &-image {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      height: auto;
      width: auto;
      max-width: 100%;
      max-height: 100%;
      margin: auto;
    }

    &-twitter {
      position: absolute;
      width: 123px;
      height: auto;
      top: 388px;
      left: 196px;
    }

    &-close-button {
      position: absolute;
      top: 10px;
      right: 20px;
      color: $normal-bg;
      font-size: calc((2 / 71) * 100vw + (528 / 71) * 1px);
    }
  }
}

// iPhone X 用
@media screen and (max-width: 480px) and (min-height: 635px) {
  .modal {
    &-mobile {
      &-close-button {
        top: 54px;
        right: 13px;
      }

      &-twitter {
        width: 130px;
        top: 450px;
        left: 198px;
      }
    }
  }
}

// iPad用
@media screen and (min-width: 768px) {
  .modal {
    &-mobile {
      &-close-button {
        top: 18px;
        right: 117px;
      }

      &-twitter {
        width: 203px;
        top: 645px;
        left: 410px;
      }
    }
  }
}

// PC用
@media screen and (min-width: 769px) {
  .modal {
    &-mobile {
      &-close-button {
        top: 15px;
        right: 180px;
      }

      &-twitter {
        width: 212px;
        top: 665px;
        left: 55.5%;
      }
    }
  }
}
</style>
